// ============================================
// src/apiConfig.js
// ============================================
// Single source of truth for Connect API URLs.
// Points to the shared Narbodica backend (same as Spark).
//
// Updated 2 May 2026 (Cassiopeia stretch 12) — added env var
// fallback pattern so deployments can override the URL via
// REACT_APP_API_URL without code changes.
//
// Audit: grep -rn 'dating-app-backend-production' src/
// — count should be 1 (this file).
// ============================================

const BASE_URL =
  process.env.REACT_APP_API_URL ||
  'https://dating-app-backend-production-a927.up.railway.app';

export const API_BASE = BASE_URL;
export const API_URL = BASE_URL;
export const CONNECT_URL = `${BASE_URL}/api/connect`;
